import { grey } from "designSystem/styles/color";
import { ColorSpec } from "designSystem/components/colorchip/ColorChipArrayStore";
import { Box, ColorChipArray, Text } from "designSystem/index";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";
import blackImage from "./Black.jpg";
import blueImage from "./Blue.jpg";
import greenImage from "./Green.jpg";
import greyImage from "./Grey.jpg";
import redImage from "./Red.jpg";
import silverImage from "./Silver.jpg";
import yellowImage from "./Yellow.jpg";

export default () => {
	const colors: ColorSpec[] = [
		{
			name: "No Image",
		},
		{
			name: "Blue",
			image: blueImage,
		},
		{
			name: "Black",
			image: blackImage,
		},
		{
			name: "Grey",
			image: greyImage,
		},
		{
			name: "Silver",
			image: silverImage,
		},
		{
			name: "Green",
			image: greenImage,
		},
		{
			name: "Yellow",
			image: yellowImage,
		},
		{
			name: "No Image 2",
		},
		{
			name: "Red",
			image: redImage,
		},
		{
			name: "Black 2",
			image: blackImage,
		},
		{
			name: "Silver 2",
			image: silverImage,
		},
	];

	for (let i = 0; i < colors.length; i++) {
		colors[i].id = i.toString();
	}

	return (
		<CssColumnGrid columns={2}>
			<Text semiBold text="default" />
			<Text semiBold text="value" />
			<Box
				bgcolor={grey[100]}
				border={STANDARD_BORDER_STYLE}
				display="inline-block"
				p={2}
				width={200}
			>
				<ColorChipArray colors={colors} />
			</Box>
			<Box
				bgcolor={grey[100]}
				border={STANDARD_BORDER_STYLE}
				display="inline-block"
				p={2}
				width={200}
			>
				<ColorChipArray colors={colors} value={colors[8]} />
			</Box>
		</CssColumnGrid>
	);
};